var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _c("ExpandableDataTableRow", {
        attrs: {
          item: _vm.item,
          label: _vm.label,
          level: _vm.level,
          canWrite: _vm.canWrite,
          visible: _vm.visible
        },
        on: {
          "select-item": function($event) {
            return _vm.$emit("select-item", $event)
          },
          clone: function($event) {
            return _vm.$emit("clone", $event)
          },
          delete: function($event) {
            return _vm.$emit("delete", $event)
          },
          edit: function($event) {
            return _vm.$emit("edit", $event)
          },
          statistics: function($event) {
            return _vm.$emit("statistics", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }